
import { useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import getImageLink from '../../utils/getImageLink';

const CustomCarousel2 = ({ images }: any) => {
  const [firstImgLoaded, setFirstImgLoaded] = useState(false);
  if (images.length === 0) {
    return <></>
  }
  return (
    <>
      <img
        src={getImageLink(images[0].link, 1000)}
        alt={`Slide 0`}
        style={{ display: "none" }}
        onLoad={() => setFirstImgLoaded(true)}
      />
      {firstImgLoaded && (
        <Carousel
          animation='slide'
          autoPlay
          navButtonsAlwaysVisible
          stopAutoPlayOnHover
          indicators
          navButtonsProps={
            {
              style: {
                opacity: 0.6,
                marginTop: '90px',
                width: '20px',
                height: '20px'
              }
            }
          }
          indicatorContainerProps={{
            style: {
              marginTop: '-30px',
              position: 'relative',
              height: '30px',
              zIndex: 1
            }
          }}
          interval={5000}
        >
          {images.map((element: any, i: number) => (
            <a rel="noreferrer" onClick={() => {
              if (element.url !== "") {
                window.open(element.url);
              }
            }} key={i} style={{ zIndex: "-5" }}>
              <img
                src={getImageLink(element.link, 1000)}
                alt={`Slide ${i}`}
                style={{ width: `100%`, cursor: "pointer" }}
                className="carousel__img"
              />
            </a>
          ))}
        </Carousel>
      )}
    </>
  );
};

export default CustomCarousel2;